import { FormControlLabel, styled } from '@mui/material';

export const CustomFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
  fontFamily: "'Poppins', sans-serif",
  marginLeft: '-8px',
  fontSize: '16px',
  '& .MuiFormControlLabel-label': {
    fontFamily: "'Poppins', sans-serif",
  },
  '& .MuiCheckbox-root': {
    color: theme.palette.primary.main,
    '&.Mui-checked': {
      color: theme.palette.secondary.main,
    },
  },
}));
